<button
  type="button"
  [class]="
    'flex items-center cursor-pointer transition-all shadow-(--profile-selector-shadow) ' +
    (config().size === 'lg' ? 'border border-solid ' : '') +
    (config().fluid ? 'w-full justify-between' : '')
  "
  [ngStyle]="buttonStyle()"
  (click)="onClick()"
>
  <div
    class="flex items-center"
    [style.gap]="gapVariable()"
  >
    <app-dynamic
      componentName="Avatar"
      [props]="{ config: avatarConfig() }"
    />

    <div class="shrink-0">
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: textConfig() }"
      />
    </div>
  </div>

  @if (config().showIcon) {
    <div
      class="shrink-0 transition-transform duration-200"
      [class.rotate-180]="state() === 'active'"
    >
      <app-dynamic
        componentName="SvgIcon"
        [props]="{
          name: 'caret-down',
          size: iconSize(),
          color: iconColor(),
        }"
      />
    </div>
  }
</button>
